import { UserContactData } from './user-contact-data';

export interface LoadAccessorialRequestAvailabilityData {
  hasCarrierRequestedAccessorials: boolean;
  hasAccessorials: boolean;
  accessorialRequestsLocked: boolean;
  canAccessorialsBeLocked: boolean;
  unlockedUser: UserContactData;
}
